const ar = {
  // ── Common ────────────────────────────────────────
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    create: 'إنشاء',
    update: 'تحديث',
    edit: 'تعديل',
    close: 'إغلاق',
    confirm: 'تأكيد',
    search: 'بحث',
    loading: 'جاري التحميل...',
    noData: 'لا توجد بيانات',
    actions: 'إجراءات',
    status: 'الحالة',
    name: 'الاسم',
    description: 'الوصف',
    type: 'النوع',
    all: 'الكل',
    active: 'نشط',
    inactive: 'غير نشط',
    online: 'متصل',
    offline: 'غير متصل',
    idle: 'خامل',
    back: 'رجوع',
    logout: 'تسجيل الخروج',
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    notifications: 'الإشعارات',
    version: 'الإصدار 2.1.0',
    language: 'اللغة',
    systemsOperational: 'جميع الأنظمة تعمل',
    liveDataConnected: 'البيانات المباشرة متصلة',
    skipToContent: 'انتقل إلى المحتوى الرئيسي',
    openNavigation: 'فتح قائمة التنقل',
    closeNavigation: 'إغلاق قائمة التنقل',
  },

  // ── Auth ──────────────────────────────────────────
  auth: {
    title: 'أومني تريس',
    subtitle: 'تسجيل الدخول إلى حسابك',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    signIn: 'تسجيل الدخول',
    invalidCredentials: 'بيانات الاعتماد غير صحيحة',
    secureWorkspace: 'مساحة عمل آمنة',
    liveIntelligence: 'ذكاء الأسطول المباشر',
    heroLine1: 'كل مركبة.',
    heroLine2: 'صورة واحدة واضحة.',
    heroSubtitle: 'حوّل الموقع المباشر وصحة الأسطول وسلامة السائق والعمليات إلى قرارات فورية قابلة للتنفيذ.',
    realTimeInsight: 'رؤية لحظية',
    secureDesign: 'أمان مدمج في التصميم',
    brandTagline: 'عمليات الأسطول، مترابطة بسلاسة.',
    protectedAccess: 'وصول مشفّر مع مراقبة النشاط',
  },

  // ── Navigation ────────────────────────────────────
  nav: {
    myDevices: 'أجهزتي',
    dashboard: 'لوحة القيادة',
    driver: 'السائق',
    identity: 'الهوية',
    users: 'المستخدمون',
    roles: 'الأدوار',
    devices: 'الأجهزة',
    allDevices: 'جميع الأجهزة',
    sensorDefinitions: 'تعريفات المستشعرات',
    deviceAssignments: 'تعيينات الأجهزة',
    digitalTwin: 'التوأم الرقمي',
    ruleEngine: 'محرك القواعد',
    rules: 'القواعد',
    alerts: 'التنبيهات',
    liveMap: 'الخريطة المباشرة',
    tripPlayback: 'إعادة تشغيل الرحلة',
    geofences: 'السياج الجغرافي',
    trips: 'الرحلات',
    dispatch: 'الإرسال',
    maintenance: 'الصيانة',
    remoteControl: 'التحكم عن بُعد',
    analytics: 'التحليلات',
    notifications: 'الإشعارات',
    sendNotification: 'إرسال إشعار',
    trustCircle: 'دائرة الثقة',
    deviceGroups: 'مجموعات الأجهزة',
    billing: 'الفواتير',
    reports: 'التقارير',
    security: 'الأمان',
    fuelAnalytics: 'تحليلات الوقود',
    audiences: 'مجموعات الإشعار',
  },

  // ── Dashboard ─────────────────────────────────────
  dashboard: {
    title: 'لوحة القيادة',
    overview: 'نظرة عامة حتى',
    myAccount: 'حسابي',
    devicesCount: 'الأجهزة',
    onlineCount: '{{count}} متصل',
    usersCount: 'المستخدمون',
    inYourTenant: 'في مؤسستك',
    activeAlerts: 'التنبيهات النشطة',
    recentAlerts: 'آخر التنبيهات',
    recentNotifications: 'آخر الإشعارات',
    unreadNotifications: '{{count}} إشعارات غير مقروءة',
    noAlerts: 'لا توجد تنبيهات حديثة',
    noNotifications: 'لا توجد إشعارات حديثة',
    deviceStatus: 'حالة الأجهزة',
    organization: 'المؤسسة',
    tenantId: 'معرّف المؤسسة',
    plan: 'الخطة',
    roles: 'الأدوار',
    visibleDevices: 'الأجهزة المرئية',
    online: 'متصل',
    idle: 'خامل',
    parked: 'متوقف',
    towing: 'قيد السحب',
    offline: 'غير متصل',
    total: 'الإجمالي',
    leaderboard: 'لوحة متصدري السائقين',
    topDrivers: 'أفضل السائقين',
    liveOperations: 'العمليات المباشرة',
    welcomeBack: 'مرحباً بعودتك',
    commandSubtitle: 'أسطولك متصل. إليك ما يحتاج إلى اهتمامك اليوم.',
    fleetAvailability: 'جاهزية الأسطول',
    moving: 'متحرك',
    critical: 'حرج',
    liveMovement: 'تم رصد حركة مباشرة',
    liveVehicleHealth: 'صحة المركبات وحالة الاتصال مباشرة',
    noTwinData: 'ستظهر الحالة المباشرة فور بدء الأجهزة بإرسال البيانات.',
    trackedVehicle: 'مركبة متتبعة',
    alertsSubtitle: 'أحداث الأسطول مرتبة حسب الأولوية',
    clear: 'كل شيء سليم',
    quickActions: 'إجراءات سريعة',
    thisWeek: 'هذا الأسبوع',
  },

  // ── Devices ───────────────────────────────────────
  device: {
    title: 'الأجهزة',
    subtitle: 'تسجيل وإدارة أجهزة إنترنت الأشياء',
    register: 'تسجيل جهاز',
    editDevice: 'تعديل الجهاز',
    registerDevice: 'تسجيل جهاز',
    identifier: 'الرقم التسلسلي / IMEI',
    deviceType: 'نوع الجهاز',
    vehicleType: 'نوع المركبة',
    plateNumber: 'رقم اللوحة',
    ownerName: 'المالك / السائق',
    ownerPlaceholder: 'اسم المالك أو السائق',
    phoneNumber: 'رقم هاتف SIM',
    timezone: 'المنطقة الزمنية',
    created: 'تاريخ الإنشاء',
    info: 'معلومات الجهاز',
    liveTwinState: 'حالة التوأم المباشرة',
    noLiveData: 'لا توجد بيانات مباشرة بعد',
    lastSeen: 'آخر ظهور',
    updated: 'آخر تحديث',
    latitude: 'خط العرض',
    longitude: 'خط الطول',
    speed: 'السرعة',
    heading: 'الاتجاه',
    altitude: 'الارتفاع',
    health: 'صحة الجهاز',
    attachedSensors: 'المستشعرات المتصلة',
    noSensors: 'لا توجد مستشعرات متصلة',
    fuelRecords: 'سجلات الوقود',
    noFuelRecords: 'لا توجد سجلات وقود',
    theftSuspected: 'يشتبه بسرقة',
    cannotChangeId: 'لا يمكن تغيير المعرف بعد التسجيل',
    idHelperText: 'المعرف الفريد للجهاز أو IMEI',
    confirmDelete: 'سيؤدي هذا إلى حذف الجهاز وجميع بياناته نهائياً. لا يمكن التراجع عن هذا.',
    gpsTracker: 'جهاز تتبع GPS',
    vehicleObd: 'جهاز OBD للمركبة',
    assetTracker: 'جهاز تتبع الأصول',
    personal: 'شخصي',
    car: 'سيارة',
    truck: 'شاحنة',
    van: 'فان',
    motorcycle: 'دراجة نارية',
    bus: 'حافلة',
    heavyEquipment: 'معدات ثقيلة',
    other: 'أخرى',
    none: 'بدون',
    tripIdleThreshold: 'حد التوقف للرحلة (دقيقة)',
    tripIdleHelperText: 'دقائق التوقف لإنهاء الرحلة (الافتراضي 30)',
  },

  // ── Digital Twin ──────────────────────────────────
  twin: {
    title: 'التوأم الرقمي',
    subtitle: 'حالة الأجهزة المباشرة — يتم التحديث كل 10 ثوانٍ',
    noDeviceTwinData: 'لا توجد بيانات توأم رقمي بعد. أرسل بيانات المستشعرات أو GPS لرؤية حالات الأجهزة المباشرة هنا.',
    health: 'الصحة',
  },

  // ── Map ───────────────────────────────────────────
  map: {
    title: 'الخريطة المباشرة',
    trackedDevices: '{{count}} أجهزة متتبعة',
    geofenceCount: '{{count}} سياج جغرافي',
    searchVehicles: 'البحث عن مركبات...',
    noVehicles: 'لا توجد مركبات',
    fitAllDevices: 'عرض جميع الأجهزة',
    type: 'النوع',
    status: 'الحالة',
    speed: 'السرعة',
    heading: 'الاتجاه',
    seen: 'آخر ظهور',
    location: 'الموقع',
    altitude: 'الارتفاع',
    owner: 'المالك / السائق',
    vehicleType: 'نوع المركبة',
    deviceType: 'نوع الجهاز',
    phone: 'الهاتف',
    timezone: 'المنطقة الزمنية',
    lastSeen: 'آخر ظهور',
    deviceHealth: 'صحة الجهاز',
    sensorData: 'بيانات المستشعرات',
    follow: 'تتبّع',
    following: 'جارٍ التتبّع',
    openMaps: 'فتح في الخرائط',
    viewDetails: 'عرض كل التفاصيل',
    unknownDevice: 'جهاز غير معروف',
    fullscreen: 'ملء الشاشة',
    exitFullscreen: 'الخروج من ملء الشاشة',
    online: 'متصل',
    idle: 'خامل',
    parked: 'متوقف',
    towing: 'سحب',
    offline: 'غير متصل',
  },

  // ── Trip Playback ─────────────────────────────────
  playback: {
    title: 'إعادة تشغيل الرحلة',
    subtitle: 'إعادة تشغيل مسارات GPS — حدد أجهزة متعددة ونطاق زمني',
    devices: 'الأجهزة',
    selectDevices: 'اختر الأجهزة...',
    from: 'من',
    to: 'إلى',
    points: '{{count}} نقطة',
    play: 'تشغيل',
    pause: 'إيقاف مؤقت',
    restart: 'إعادة التشغيل',
    selectSubtitle: 'حدد الأجهزة ونطاقاً زمنياً، ثم انقر على رحلة لإعادة تشغيلها',
    minStop: 'أقل توقف (دقيقة)',
    stops: '{{count}} توقفات',
    stopped: '{{duration}} متوقف',
    noTripsInRange: 'لا توجد رحلات في هذا النطاق',
    noStopsDetected: 'لم يتم اكتشاف توقفات (أقل {{min}} دقيقة)',
    tripStart: 'بداية الرحلة',
    tripEnd: 'نهاية الرحلة',
    arrived: 'الوصول',
    departed: 'المغادرة',
    duration: 'المدة',
    location: 'الموقع',
    fromPrev: 'من السابق',
    openGoogleMaps: 'فتح في خرائط جوجل',
    long: 'طويل',
    medium: 'متوسط',
    short: 'قصير',
    fullscreen: 'ملء الشاشة',
    exitFullscreen: 'الخروج من ملء الشاشة',
    longest: 'الأطول',
  },

  // ── Trips ─────────────────────────────────────────
  trips: {
    title: 'الرحلات',
    tripCount: '{{count}} رحلة في النطاق المحدد',
    allDevices: 'جميع الأجهزة',
    noTrips: 'لا توجد رحلات في النطاق المحدد. ستُنشأ الرحلات تلقائياً من بيانات GPS الأجهزة المتتبعة.',
    replay: 'إعادة التشغيل',
    completed: 'مكتملة',
    active: 'نشطة',
    compare: 'مقارنة',
    comparison: 'مقارنة الرحلات',
    selectTripsToCompare: 'حدد 2-5 رحلات للمقارنة',
  },

  // ── Geofences ─────────────────────────────────────
  geofences: {
    title: 'السياج الجغرافي',
    zoneCount: '{{count}} مناطق — ارسم على الخريطة للإنشاء',
    drawGeofence: 'رسم سياج جغرافي',
    drawOnMap: 'ارسم السياج الجغرافي على الخريطة',
    noGeofences: 'لا يوجد سياج جغرافي بعد. انقر على "رسم سياج جغرافي" لإنشاء واحد على الخريطة.',
    createGeofence: 'إنشاء سياج جغرافي',
    shapeDrawn: 'تم رسم {{shape}}',
    color: 'اللون',
    radius: 'نصف القطر',
    pointCount: '{{count}} نقطة',
    notifyDriver: 'إشعار السائق المعيّن عند الدخول/الخروج',
    assignAudience: 'إشعار المجموعات',
    audienceHint: 'تتلقى هذه المجموعات إشعارًا فوريًا عند دخول جهاز إلى هذه المنطقة',
  },

  // ── Analytics ─────────────────────────────────────
  analytics: {
    title: 'التحليلات',
    subtitle: 'بيانات المستشعرات التاريخية وتحليل مسار GPS',
    device: 'الجهاز',
    sensorKey: 'مفتاح المستشعر',
    timeRange: 'النطاق الزمني',
    customRange: 'نطاق مخصص',
    last1h: 'آخر ساعة',
    last6h: 'آخر 6 ساعات',
    last12h: 'آخر 12 ساعة',
    last24h: 'آخر 24 ساعة',
    last48h: 'آخر 48 ساعة',
    last7d: 'آخر 7 أيام',
    selectDevice: 'اختر جهازاً لبدء استكشاف التحليلات.',
    speedChart: 'السرعة عبر الزمن',
    sensorChart: 'المستشعر: {{key}}',
    gpsTrack: 'مسار GPS',
  },

  // ── Rules & Alerts ────────────────────────────────
  rules: {
    title: 'القواعد',
    createRule: 'إنشاء قاعدة',
    editRule: 'تعديل القاعدة',
    eventType: 'نوع الحدث',
    conditions: 'الشروط (JSON)',
    ruleActions: 'الإجراءات (JSON)',
    noRules: 'لا توجد قواعد بعد',
    notifyDriver: 'إرسال إشعار للسائق المعيّن',
  },
  alerts: {
    title: 'التنبيهات',
    severity: 'الخطورة',
    message: 'الرسالة',
    acknowledge: 'تأكيد الاستلام',
    acknowledged: 'تم التأكيد',
    filterSeverity: 'تصفية حسب الخطورة',
  },

  // ── Notifications ─────────────────────────────────
  notifications: {
    title: 'الإشعارات',
    markAllRead: 'تعيين الكل كمقروء',
    filterUnread: 'غير المقروءة فقط',
    noNotifications: 'لا توجد إشعارات',
    deleteConfirm: 'حذف هذا الإشعار؟',
  },

  sendNotification: {
    title: 'إرسال إشعار',
    subtitle: 'إرسال إشعارات فورية لمستخدمي المؤسسة',
    notificationTitle: 'العنوان',
    titlePlaceholder: 'عنوان الإشعار',
    message: 'الرسالة',
    messagePlaceholder: 'اكتب رسالة الإشعار...',
    severity: 'الأهمية',
    info: 'معلومات',
    warning: 'تحذير',
    critical: 'حرج',
    target: 'المستلمون',
    allUsers: 'جميع المستخدمين',
    specificUsers: 'مستخدمون محددون',
    selectUsers: 'اختر المستخدمين',
    send: 'إرسال الإشعار',
    sending: 'جاري الإرسال...',
    success: 'تم إرسال الإشعار إلى {{count}} مستخدم ({{push}} إشعار فوري تم تسليمه)',
    error: 'فشل إرسال الإشعار',
    noUsers: 'لم يتم تحديد مستخدمين',
  },

  notifPrefs: {
    title: 'إعدادات الإشعارات',
    subtitle: 'التحكم في كيفية ووقت استلام التنبيهات',
    channels: 'قنوات الإشعارات',
    push: 'إشعارات الدفع',
    pushDesc: 'استلام تنبيهات الدفع على جهازك',
    email: 'إشعارات البريد الإلكتروني',
    emailDesc: 'استلام التنبيهات الحرجة عبر البريد',
    inApp: 'الإشعارات داخل التطبيق',
    inAppDesc: 'عرض الإشعارات داخل التطبيق',
    quietHours: 'ساعات الهدوء',
    quietHoursDesc: 'إيقاف الإشعارات غير الحرجة خلال هذه الساعات. التنبيهات الحرجة تصل دائماً.',
    quietStart: 'وقت البدء',
    quietEnd: 'وقت الانتهاء',
    throttle: 'التحكم بالتكرار',
    throttleDesc: 'الحد الأدنى للفترة بين إشعارات الدفع المتكررة لنفس القاعدة والجهاز.',
    minInterval: 'الحد الأدنى للفترة',
    noThrottle: 'بدون تحكم',
    throttle1m: 'دقيقة واحدة',
    throttle5m: '5 دقائق',
    throttle15m: '15 دقيقة',
    throttle1h: 'ساعة واحدة',
    save: 'حفظ الإعدادات',
    saved: 'تم حفظ الإعدادات',
    saveFailed: 'فشل في حفظ الإعدادات',
    loadError: 'فشل في تحميل الإعدادات',
  },

  // ── Fuel ──────────────────────────────────────────
  fuel: {
    title: 'تحليلات الوقود',
    subtitle: 'استهلاك الوقود والتكاليف وكشف السرقة',
    totalConsumed: 'إجمالي الاستهلاك',
    totalCost: 'إجمالي التكلفة',
    costPerKm: 'التكلفة / كم',
    refillCount: 'عمليات التعبئة',
    theftCount: 'حوادث السرقة',
    avgConsumption: 'معدل ل/100كم',
    selectDevice: 'اختر جهازاً لعرض تحليلات الوقود',
  },

  // ── Fleet ─────────────────────────────────────────
  fleet: {
    jobs: 'الإرسال',
    createJob: 'إنشاء مهمة',
    maintenance: 'الصيانة',
    createSchedule: 'إنشاء جدول',
    commands: 'التحكم عن بُعد',
    issueCommand: 'إصدار أمر',
    selectDevice: 'اختر الجهاز',
    commandType: 'نوع الأمر',
  },

  // ── Commands ─────────────────────────────────────
  commands: {
    title: 'التحكم عن بُعد',
    subtitle: 'إرسال أوامر إلى أجهزة التتبع الخاصة بك',
    totalCommands: 'إجمالي الأوامر',
    lock: 'قفل المركبة',
    unlock: 'فتح المركبة',
    engineDisable: 'تعطيل المحرك',
    engineEnable: 'تشغيل المحرك',
    reboot: 'إعادة تشغيل الجهاز',
    lockDesc: 'قفل أبواب المركبة عن بُعد',
    unlockDesc: 'فتح أبواب المركبة عن بُعد',
    engineDisableDesc: 'قطع طاقة المحرك — لا يمكن تشغيل المركبة',
    engineEnableDesc: 'استعادة طاقة المحرك',
    rebootDesc: 'إعادة تشغيل جهاز التتبع',
    confirmDangerous: 'هذه عملية خطيرة. سيتم تعطيل المحرك ولن تتمكن المركبة من التشغيل. هل أنت متأكد؟',
    queued: 'في قائمة الانتظار',
    sent: 'تم الإرسال',
    acknowledged: 'تم التأكيد',
    failed: 'فشل',
    issuedBy: 'صادر من',
    issuedAt: 'تاريخ الإصدار',
    completedAt: 'تاريخ الإكمال',
    noCommands: 'لم يتم إصدار أوامر بعد',
    commandSent: 'تم إرسال الأمر بنجاح',
    commandFailed: 'فشل إرسال الأمر',
  },

  // ── Maintenance ──────────────────────────────────
  maintenance: {
    title: 'الصيانة',
    schedulesConfig: 'الجداول والإعدادات',
    serviceOrders: 'أوامر الخدمة',
    newSchedule: 'جدول جديد',
    task: 'المهمة',
    everyKm: 'كل (كم)',
    everyDays: 'كل (يوم)',
    noSchedules: 'لا توجد جداول صيانة بعد',
    addCategory: 'إضافة فئة',
    addType: 'إضافة نوع',
    categoriesTypes: 'الفئات والأنواع',
    newServiceOrder: 'أمر خدمة جديد',
    orderTitle: 'العنوان',
    description: 'الوصف',
    priority: 'الأولوية',
    serviceType: 'نوع الخدمة',
    odometer: 'عداد المسافة (كم)',
    cost: 'التكلفة',
    vendor: 'المورّد',
    vendorContact: 'جهة اتصال المورّد',
    notes: 'ملاحظات',
    status: 'الحالة',
    open: 'مفتوح',
    inProgress: 'قيد التنفيذ',
    completed: 'مكتمل',
    closed: 'مغلق',
    reportIssue: 'الإبلاغ عن مشكلة',
    noServiceOrders: 'لا توجد أوامر خدمة بعد',
    noIssues: 'لا توجد مشاكل مبلّغ عنها',
    issueTitle: 'عنوان المشكلة',
    issueSeverity: 'الخطورة',
    resolveIssue: 'حل المشكلة',
    low: 'منخفضة',
    normal: 'عادية',
    high: 'عالية',
    urgent: 'عاجلة',
  },

  // ── Jobs ─────────────────────────────────────────
  jobs: {
    title: 'الإرسال',
    subtitle: 'إدارة مهام التوصيل وتعيينات السائقين',
    customerName: 'اسم العميل',
    customerPhone: 'هاتف العميل',
    pickupAddress: 'عنوان الاستلام',
    dropoffAddress: 'عنوان التسليم',
    assignDriver: 'تعيين سائق',
    assignVehicle: 'تعيين مركبة',
    scheduledAt: 'الموعد المجدول',
    priority: 'الأولوية',
    notes: 'ملاحظات',
    noJobs: 'لا توجد مهام بعد',
    pending: 'قيد الانتظار',
    assigned: 'تم التعيين',
    accepted: 'تم القبول',
    enRoute: 'في الطريق',
    inProgress: 'قيد التنفيذ',
    completed: 'مكتملة',
    cancelled: 'ملغاة',
    reference: 'المرجع',
  },

  // ── Billing ───────────────────────────────────────
  billing: {
    title: 'الفواتير والاستخدام',
    subtitle: 'إدارة اشتراكك ومدفوعاتك',
    subscription: 'الاشتراك',
    plan: 'الخطة',
    expiresIn: 'ينتهي خلال {{days}} يوم',
    renew30: 'تجديد +30 يوم',
    renew1y: 'تجديد +سنة',
    usageSummary: 'ملخص الاستخدام',
    paymentSuccess: 'تمت عملية الدفع بنجاح!',
    paymentFailed: 'فشلت عملية الدفع',
    currentSubscription: 'الاشتراك الحالي',
    pricingTiers: 'مستويات الأسعار',
    configurePlan: 'تهيئة الخطة',
    numberOfDevices: 'عدد الأجهزة',
    billingCycle: 'دورة الفوترة',
    monthly: 'شهري',
    quarterly: 'ربع سنوي',
    semiAnnual: 'نصف سنوي',
    annual: 'سنوي',
    price: 'السعر',
    subscribe: 'اشتراك',
    upgrade: 'ترقية',
    processing: 'جاري المعالجة...',
    selectGateway: 'اختر طريقة الدفع',
    devices: 'أجهزة',
    remainingDays: 'الأيام المتبقية',
    noSubscription: 'لا يوجد اشتراك نشط',
    planStatus: 'حالة الخطة',
    deviceUsage: 'استخدام الأجهزة',
    devicesUsed: '{{used}} من {{limit}} جهاز مستخدم',
    startedAt: 'تاريخ البدء',
    expiresAt: 'تاريخ الانتهاء',
    daysLeft: '{{days}} يوم متبقي',
    expired: 'منتهي',
    walletBalance: 'رصيد المحفظة',
    recentTransactions: 'المعاملات الأخيرة',
    noTransactions: 'لا توجد معاملات بعد',
    topup: 'شحن',
    deduction: 'خصم',
    subscriptionPayment: 'اشتراك',
  },

  // ── Trust Circle ──────────────────────────────────
  trustCircle: {
    title: 'دائرة الثقة',
    subtitle: 'مشاركة الوصول إلى الأجهزة بين المؤسسات',
    accessGranted: 'الوصول الممنوح',
    accessReceived: 'الوصول المستلم',
    grantAccess: 'منح الوصول',
    revokeAccess: 'إلغاء الوصول',
    targetTenant: 'معرّف المؤسسة المستهدفة',
    selectDevices: 'اختر الأجهزة',
    permissions: 'الصلاحيات',
    expiresAt: 'تاريخ الانتهاء',
    noGranted: 'لا يوجد وصول ممنوح لمؤسسات أخرى',
    noReceived: 'لا يوجد وصول مستلم من مؤسسات أخرى',
    accept: 'قبول',
    decline: 'رفض',
  },

  // ── Users ─────────────────────────────────────────
  users: {
    title: 'المستخدمون',
    subtitle: 'إدارة المستخدمين في مؤسستك',
    addUser: 'إضافة مستخدم',
    editUser: 'تعديل المستخدم',
    assignRole: 'تعيين دور',
    noRoles: 'بدون أدوار',
    confirmDelete: 'سيؤدي هذا إلى حذف المستخدم نهائياً. لا يمكن التراجع عن هذا.',
    email: 'البريد الإلكتروني',
    name: 'الاسم',
    password: 'كلمة المرور',
    role: 'الدور',
    detail: 'تفاصيل المستخدم',
    profile: 'الملف الشخصي',
    noUsers: 'لا يوجد مستخدمون بعد',
  },
  roles: {
    title: 'الأدوار والصلاحيات',
    subtitle: 'تعريف الأدوار وتعيين الصلاحيات',
    createRole: 'إنشاء دور',
    editPermissions: 'تعديل الصلاحيات',
    deleteRole: 'حذف الدور',
    roleName: 'اسم الدور',
    noRoles: 'لا توجد أدوار بعد',
    confirmDelete: 'سيؤدي هذا إلى حذف الدور نهائياً.',
  },

  // ── Security ─────────────────────────────────────
  security: {
    title: 'الأمان',
    subtitle: 'المصادقة الثنائية والأجهزة الموثوقة',
    twoFactorAuth: 'المصادقة الثنائية',
    twoFAEnabled: 'المصادقة الثنائية مفعّلة',
    twoFANotSetUp: 'المصادقة الثنائية غير مُعدّة',
    enforced: 'إلزامية',
    twoFARequired: 'المصادقة الثنائية مطلوبة لمؤسستك',
    myTrustedDevices: 'أجهزتي الموثوقة',
    allTenantDevices: 'جميع أجهزة المؤسسة',
    deviceName: 'اسم الجهاز',
    ipAddress: 'عنوان IP',
    lastUsed: 'آخر استخدام',
    expiresAt: 'تاريخ الانتهاء',
    revoke: 'إلغاء',
    noDevices: 'لا توجد أجهزة موثوقة',
    changePassword: 'تغيير كلمة المرور',
    changePasswordSubtitle: 'قم بتحديث كلمة المرور التي تستخدمها لتسجيل الدخول',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    passwordMismatch: 'كلمتا المرور غير متطابقتين',
    passwordTooShort: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح',
    passwordChangeFailed: 'فشل تغيير كلمة المرور',
    wrongCurrentPassword: 'كلمة المرور الحالية غير صحيحة',
    save: 'حفظ',
  },

  // ── Two-Factor ────────────────────────────────────
  twoFactor: {
    title: 'المصادقة الثنائية',
    subtitle: 'أدخل الرمز من تطبيق المصادقة',
    enterCode: 'أدخل الرمز المكون من 6 أرقام',
    verify: 'تحقق',
    backToLogin: 'العودة لتسجيل الدخول',
    setupTitle: 'إعداد المصادقة الثنائية',
    scanQR: 'امسح رمز QR هذا بتطبيق المصادقة',
    enterManually: 'أو أدخل هذا المفتاح يدوياً',
    secretKey: 'المفتاح السري',
    confirmCode: 'أدخل الرمز لتأكيد الإعداد',
    activate: 'تفعيل المصادقة الثنائية',
  },

  // ── Device Groups ─────────────────────────────────
  deviceGroups: {
    title: 'مجموعات الأجهزة',
    subtitle: 'تنظيم الأجهزة في مجموعات منطقية',
    create: 'إنشاء مجموعة',
    noGroups: 'لا توجد مجموعات أجهزة بعد',
    manageGroup: 'إدارة المجموعة',
    groupName: 'اسم المجموعة',
    assignDevices: 'تعيين الأجهزة',
    assignUsers: 'تعيين المستخدمين',
    confirmDelete: 'سيؤدي هذا إلى حذف المجموعة نهائياً.',
  },

  // ── Audience Groups ────────────────────────────────
  audiences: {
    title: 'مجموعات الإشعار',
    subtitle: 'إرسال إشعارات لمجموعات من الأشخاص عند وقوع أحداث المناطق',
    create: 'إنشاء مجموعة',
    members: 'الأعضاء',
    addMember: 'إضافة عضو',
    memberName: 'الاسم',
    memberPhone: 'رقم الهاتف',
    platformUser: 'مستخدم المنصة',
    externalContact: 'جهة اتصال خارجية',
    externalHint: 'ستتلقى جهات الاتصال الخارجية رسائل واتساب/SMS عند إطلاق الإرسال متعدد القنوات',
    preset: 'القالب',
    presetGeneric: 'عام',
    presetSchool: 'النقل المدرسي',
    noGroups: 'لا توجد مجموعات بعد. أنشئ مجموعة لبدء إرسال الإشعارات.',
  },

  // ── Device Assignments ────────────────────────────
  deviceAssignments: {
    title: 'تعيينات الأجهزة',
    subtitle: 'التحكم في الأجهزة التي يمكن لكل مستخدم رؤيتها',
    selectUser: 'اختر المستخدم',
    devicesVisibleTo: 'الأجهزة المرئية لـ {{user}}',
    noDevices: 'لا توجد أجهزة معيّنة',
  },

  // ── Driver Dashboard ──────────────────────────────
  driver: {
    title: 'لوحة السائق',
    assignedDevices: 'الأجهزة المعيّنة',
    onlineDevices: 'الأجهزة المتصلة',
    recentAlerts: 'آخر التنبيهات',
    noAlerts: 'لا توجد تنبيهات حديثة',
  },

  // ── Viewer Dashboard ──────────────────────────────
  viewer: {
    title: 'لوحة المشاهد',
    assignedDevices: 'الأجهزة المعيّنة',
    lastActivity: 'آخر نشاط',
  },

  // ── Share Tracking ────────────────────────────────
  share: {
    title: 'التتبع المباشر',
    loading: 'جاري تحميل بيانات التتبع...',
    invalidLink: 'رابط التتبع غير صالح أو منتهي الصلاحية',
    lastSeen: 'آخر ظهور',
    speed: 'السرعة',
  },

  // ── Ingestion ─────────────────────────────────────
  ingestion: {
    title: 'استيعاب البيانات',
    subtitle: 'استيعاب بيانات القياس عن بُعد للأجهزة',
  },

  // ── Reports ────────────────────────────────────
  reports: {
    title: 'التقارير',
    subtitle: 'إنشاء وجدولة وتحميل تقارير الأسطول',
    templates: 'القوالب',
    schedules: 'الجداول',
    history: 'السجل',
    generateNow: 'إنشاء الآن',
    generated: 'تم إنشاء التقرير بنجاح',
    checkHistory: 'تحقق من تبويب السجل للتحميل',
    noTemplates: 'لا توجد قوالب تقارير متاحة',
    createSchedule: 'إنشاء جدول',
    reportType: 'نوع التقرير',
    frequency: 'التكرار',
    dateRange: 'نطاق التاريخ',
    filterDevices: 'تصفية الأجهزة (اتركها فارغة للكل)',
    filterVehicleTypes: 'تصفية حسب نوع المركبة',
    emailTo: 'مستلمو البريد الإلكتروني',
    emailHelperText: 'عناوين بريد إلكتروني مفصولة بفواصل لتسليم التقرير',
    nextRun: 'التشغيل التالي',
    fileSize: 'الحجم',
    generatedAt: 'تاريخ الإنشاء',
    download: 'تحميل',
  },

  // ── Sensor Definitions ────────────────────────────
  sensors: {
    title: 'تعريفات المستشعرات',
    subtitle: 'تعريف أنواع المستشعرات المتاحة وبياناتها الوصفية',
    createSensor: 'إنشاء تعريف مستشعر',
    key: 'المفتاح',
    keyLabel: 'المفتاح (مثال: temperature)',
    keyHelperText: 'معرّف بصيغة snake_case يُستخدم في البيانات',
    displayName: 'الاسم المعروض',
    unit: 'الوحدة',
    unitLabel: 'الوحدة (مثال: °C, km/h)',
    dataType: 'نوع البيانات',
  },

  // ── Sensor Names ──
  sensorNames: {
    battery_voltage: 'جهد البطارية',
    gsm_signal: 'إشارة GSM',
    acc: 'مقياس التسارع',
    charging: 'الشحن',
    speed: 'السرعة',
    fuel_level: 'مستوى الوقود',
    temperature: 'درجة الحرارة',
    humidity: 'الرطوبة',
    rpm: 'عدد الدورات',
    odometer: 'عداد المسافة',
    engine_load: 'حمل المحرك',
    coolant_temp: 'حرارة سائل التبريد',
    door_status: 'حالة الباب',
    ignition: 'الإشعال',
    alarm_type: 'نوع الإنذار',
    external_voltage: 'الجهد الخارجي',
    fuel_consumption: 'استهلاك الوقود',
    tire_pressure: 'ضغط الإطارات',
    altitude: 'الارتفاع',
    heading: 'الاتجاه',
    oil_pressure: 'ضغط الزيت',
    throttle_position: 'وضع دواسة الوقود',
    transmission_temp: 'حرارة ناقل الحركة',
    brake_fluid_level: 'مستوى سائل الفرامل',
    abs_status: 'حالة نظام ABS',
    airbag_status: 'حالة الوسائد الهوائية',
    seatbelt_status: 'حالة حزام الأمان',
    harsh_braking: 'فرملة قوية',
    harsh_acceleration: 'تسارع قوي',
    sharp_turn: 'انعطاف حاد',
    towing_detected: 'كشف السحب',
    crash_detected: 'كشف الاصطدام',
    tamper_alert: 'تنبيه العبث',
    jamming_detected: 'كشف التشويش',
  },
}

export default ar
